

















import Vue, { PropType } from 'vue';
import { VFairHackConfig, VFairPavilion } from '~/services/types/vfair';
import { getMainDomainUrl } from '~/utils/urlUtils';
import URLS from '~/URLS';

// Assets
import DefaultBackground from '~/assets/img/vcf/pavilion_default.png';
import DialogService from '~/services/DialogService';

// 2022-08-19: Anders
// NB! This code contains logic for a 'ExternalVFairLinkMode' which is a mode for
// sending a user to a different vfair. This is not a feature we officially support
// but are currently a hack that we are implementing in this component as a temporarily solution.
// This hack can be removed after the EFMD Global VFair of October 2022.

export default Vue.extend({
    name: 'PavilionButton',
    props: {
        pavilion: {
            type: Object as PropType<VFairPavilion>,
            required: true,
            default: () => ({} as VFairPavilion),
        },
    },
    computed: {
        backgroundImageUrl(): string {
            return !!this.pavilion.image ? this.pavilion.image : DefaultBackground;
        },

        // VFAIR HACK
        isModeExternalVFairLink(): boolean {
            // Is VFair the EFMD Global Fair?
            return Boolean(
                this.vFairHackConfig &&
                    this.pavilion.id ===
                        this.vFairHackConfig.pavillions.external.hostVFairPavillionId
            );
        },
        vFairHackConfig(): VFairHackConfig | null {
            return (this as any).$interfaces.vfairModule.getVFairHackConfig();
        },
        // END VFAIR HACK
    },
    methods: {
        goToPavilion() {
            // VFAIR HACK
            if (this.isModeExternalVFairLink && this.vFairHackConfig) {
                const targetVFairId = this.vFairHackConfig.pavillions.external.externalVFairId;
                // This text is not translated with i18n, as it is a temporary solution
                // and will be removed in the future.
                DialogService.openDialog({
                    title: 'Enter this Virtal Fair?',
                    contentHTML: `When you enter <strong>${
                        this.vFairHackConfig.pavillions.external.externalVFairName
                    }</strong> - you can return to the EFMD Global Fair with a single click in the top menu.`,
                    actions: [
                        {
                            title: 'Cancel',
                            action: ({ res }: { res: Function }) => {
                                res();
                            },
                        },
                        {
                            title: 'Enter',
                            variant: 'primary',
                            action: () => {
                                const subDomain = this.vFairHackConfig!!.pavillions.external
                                    .externalPlatformSubdomain;

                                window.open(
                                    `https://${subDomain}.${getMainDomainUrl()}${
                                        URLS.vfair
                                    }/${targetVFairId}?referrer=${encodeURIComponent(
                                        window.location.href
                                    )}`,
                                    '_self'
                                );
                            },
                        },
                    ],
                });

                return;
            }
            // END VFAIR HACK

            this.$emit('click');
        },
    },
});
